/*
 *
 * @desc: RSA加密解密
 * @author: haifn
 * @time: 2021/3/11 11:22
 *
 */
import { KEY_BE_PUBLIC, KEY_FE_PRIVATE, KEY_FE_PUBLIC } from '@@/constants/crypto';

let JSEncrypt = null;
const getJSEncrypt = () => {
  JSEncrypt = JSEncrypt ?? require('jsencrypt').default;
  return new JSEncrypt();
};
let FEJsenrypt = null;
let BEJsenrypt = null;

/** 给后端传加密字符串的 */
function encryptBE(data) {
  const jsencrypt = FEJsenrypt || getJSEncrypt();
  jsencrypt.setPublicKey(KEY_BE_PUBLIC.slice(0, -2));
  return encodeURIComponent(jsencrypt.encrypt(data));
}

function encodeURIEncryptFE(data) {
  const jsencrypt = FEJsenrypt || getJSEncrypt();
  jsencrypt.setPublicKey(KEY_FE_PUBLIC.slice(0, -2));
  const res = jsencrypt.encrypt(data + '');
  return encodeURIComponent(res);
}

function decodeURIDecryptFE(encryptData) {
  const jsencrypt = BEJsenrypt || getJSEncrypt();
  const data = decodeURIComponent(encryptData);
  jsencrypt.setPrivateKey(KEY_FE_PRIVATE.slice(0, -2));
  return jsencrypt.decrypt(data);
}

export { encryptBE, encodeURIEncryptFE, decodeURIDecryptFE };
